import { assets } from "@/lib/assets";
import { Linkedin, BookOpen } from "lucide-react";

export const FounderFeature = () => {
  return (
    <section
      id="founder"
      data-testid="founder-feature-section"
      className="relative bg-[color:var(--kat-navy)] text-white overflow-hidden grain"
    >
      {/* subtle accents */}
      <div
        className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(56,189,248,0.22), transparent 70%)",
        }}
        aria-hidden
      />

      <div className="kat-container grid lg:grid-cols-12 gap-12 lg:gap-20 items-center py-24 md:py-32 relative">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] w-full max-w-md">
            <div
              className="absolute -inset-4 border border-[color:var(--kat-sky)]/60 rounded-sm"
              aria-hidden
            />
            <img
              src={assets.founderOrange}
              alt="Karlene A Thomas, BSc. — Founder, KAT Consulting & Branding Inc."
              data-testid="founder-image"
              className="relative w-full h-full object-cover rounded-sm shadow-2xl"
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-[11px] tracking-[0.28em] uppercase font-semibold text-[color:var(--kat-sky)]">
            Meet the Founder
          </p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Karlene A Thomas, BSc. — building an institution that
            <span className="italic text-[color:var(--kat-sky)]"> leads with intention.</span>
          </h2>
          <p className="mt-8 text-lg leading-relaxed text-white/85 max-w-2xl">
            A consultant, trainer, and Branding Expert, Karlene A Thomas, BSc. founded
            KAT Consulting & Branding to serve organizations and professionals that
            want more than surface-level wins. Every engagement is grounded in three
            commitments: clarity in strategy, confidence in execution, and purpose in
            the outcomes we create.
          </p>

          {/* External links: LinkedIn + Amazon book */}
          <div className="mt-8 flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 sm:gap-4">
            <a
              href="https://www.linkedin.com/in/karlene-thomas-readytowork"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-linkedin-link"
              className="inline-flex items-center gap-2 border border-white/25 hover:border-[color:var(--kat-sky)] hover:text-[color:var(--kat-sky)] text-white/90 text-sm font-medium px-5 py-2.5 rounded-sm transition-colors kat-focus"
            >
              <Linkedin size={16} strokeWidth={1.6} />
              Connect on LinkedIn
            </a>
            <a
              href="https://amazon.com/dp/B09R366FDP"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-amazon-link"
              className="inline-flex items-center gap-2 bg-[color:var(--kat-orange)] hover:brightness-110 text-white text-sm font-medium px-5 py-2.5 rounded-sm transition-all kat-focus"
              style={{ boxShadow: "0 10px 30px -12px rgba(249,115,22,0.55)" }}
            >
              <BookOpen size={16} strokeWidth={1.6} />
              Get my Confidence Journal on Amazon
            </a>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-8 border-t border-white/15 pt-10">
            <div>
              <p className="font-serif text-4xl">Clarity</p>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">
                Diagnose before you decide — every plan starts with truth.
              </p>
            </div>
            <div>
              <p className="font-serif text-4xl">Confidence</p>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">
                Guide the operator, then equip them with the systems.
              </p>
            </div>
            <div>
              <p className="font-serif text-4xl">Purpose</p>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">
                Growth that lifts communities, not just quarterly numbers.
              </p>
            </div>
          </div>

          <a
            href="#contact"
            data-testid="founder-cta"
            className="mt-12 inline-flex items-center gap-3 bg-white text-[color:var(--kat-navy)] hover:bg-[color:var(--kat-sky)] hover:text-[color:var(--kat-navy)] transition-colors text-sm font-medium px-8 py-4 rounded-sm"
          >
            Book a Discovery Call
            <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FounderFeature;
